import React from 'react'
import styled from '@emotion/styled'

interface DivStyledProps {
  row?: boolean
  bottomPadding?: boolean
}

interface SectionRowProps
  extends React.HTMLAttributes<HTMLDivElement>,
    DivStyledProps {}

const Div = styled.div<DivStyledProps>`
  max-width: 750px;
  padding-bottom: ${({ bottomPadding }) => (bottomPadding ? '20px' : '0px')};
  display: ${({ row }) => (row === true ? 'grid' : 'block')};
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

const SectionRow: React.FC<SectionRowProps> = ({
  children,
  bottomPadding = true,
  ...props
}) => {
  return (
    <Div {...props} bottomPadding={bottomPadding}>
      {children}
    </Div>
  )
}

export default SectionRow
